import { useState } from 'react';

import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import Popover from '@mui/material/Popover';
import { alpha } from '@mui/material/styles';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';

import { account } from '../../../_mock/account';

import { useRouter } from '../../../routes/hooks';


import {useSelector} from 'react-redux'

// ----------------------------------------------------------------------
import {useDispatch} from 'react-redux'
//import axios from '../../../Config/Interceptor';
import axios from 'axios';
import { Base_URL } from '../../../Config/Config';
import { toast } from 'react-toastify';



const MENU_OPTIONS = [
  /*{
    label: 'Home',
    icon: 'eva:home-fill',
  },

  {
    label: 'Profile',
    icon: 'eva:person-fill',
  },*/
  // {
  //   label: 'Settings',
  //   icon: 'eva:settings-2-fill',
  // },
];

// ----------------------------------------------------------------------

export default function AccountPopover() {

  const router = useRouter()


  const dispatch  =  useDispatch()
  const LoginData  = useSelector((state)=> state.LoginReducer && state.LoginReducer.data ? state.LoginReducer.data : {} ) 
  const AdminID  = useSelector((state)=> state.LoginReducer && state.LoginReducer.data && state.LoginReducer.data.admin_id && state.LoginReducer.data.admin_id !== null && state.LoginReducer.data.admin_id !== undefined && state.LoginReducer.data.admin_id !== "" ? state.LoginReducer.data.admin_id  : null ) 


 

  const [open, setOpen] = useState(null);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };
  
  const handleLogout = () => {
    {/*if(AdminID){
      axios.post(`${Base_URL}admin/logout/${AdminID}`)
      .then((res)=>{
        toast.success(res.data.message)
      })
      .catch((err)=>{
        toast.error(err.data.message)
      })
    }*/}
    setOpen(null);

    dispatch({type : "LOGOUT"  , data : {}})

       router.push('/login');


  };

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          width: 40,
          height: 40,
          background: (theme) => alpha(theme.palette.grey[500], 0.08),
          ...(open && {
            background: (theme) =>
              `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
          }),
        }}
      >
        <Avatar
          src={account.photoURL}
          alt={account.displayName}
          sx={{
            width: 36,
            height: 36,
            border: (theme) => `solid 2px ${theme.palette.background.default}`,
          }}
        >
          {account.displayName.charAt(0).toUpperCase()}
        </Avatar>
      </IconButton>

      <Popover
        open={!!open}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1,
            ml: 0.75,
            width: 200,
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2 }}>
          <Typography variant="subtitle2" noWrap>
            {account.displayName}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {LoginData.email}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        {MENU_OPTIONS.map((option) => (
          <MenuItem key={option.label} onClick={handleClose}>
            {option.label}
          </MenuItem>
        ))}

        <Divider sx={{ borderStyle: 'dashed', m: 0 }} />

        <MenuItem
          disableRipple
          disableTouchRipple
          onClick={handleLogout}
          sx={{ typography: 'body2', color: 'error.main', py: 1.5 }}
        >
          Logout
        </MenuItem>
      </Popover>
    </>
  );
}
